var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseCaseSpecificNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 489.673,
    height: 419.106,
    viewBox: "0 0 489.673 419.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f283a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737580"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14e2c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11ad97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#4a5160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171f32"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 13"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAANCAYAAABLjFUnAAAABHNCSVQICAgIfAhkiAAAAXhJREFUKJGlkl1OwkAUhc+UH98U4gLsDiSugFeNMbiDsgOW0CWUFbQ+GA2JwoNFDIlgCKKECBqFIEox+BN/SLXBREthfKgBEUpsvI/nnvvNnTMD2K1Im8Pmh4J1XfzdYiyHUre+EU1WfXB3ebiMMNwGh41PfvLJRcVD8jUVh9cUWYUb6u09lRBvhQAAUY0j222KSLvvGdmMMO8SdehhTOlBOAwRuSvTfNDk4dJfsTQrAABWpyXq7ATh7orYMoHOIVK1EKCGzmJ+IQAATLHC9gwi4rg2h64eQo9hh/wrXgnxFz/p9kQaVRuDhpJjSf1IxWV+OKvTcwknZYpCNWAZTeIxBrlVGgj3qTTTzPBjzRdn3FgdAFKKh+zfqUg++E1BTYTIczJtOTCpsvUYMjfCN0j2EU1uQN1lbYOK5QDy1f71nMQBiYKm4V1s2GURZ0egoD+y1GSOaDKFJnO2N6sU2VHxbSdkAuPWL/aHMj/tzLJAQdcYQv3/gX0BJF+hPNHZNtsAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 11 13"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAABHNCSVQICAgIfAhkiAAAAT1JREFUKJGNkL9Kw2AUxX/3S9ogOMQHECMIbtIuDk7NE2gnF4c+go/QR/ANrJNjO6kgmAjt4D/aTdEhVgQVhK8IpU1T8zmI1WgHz3jP797LOTBNb4cV0UcafVya6v+WejmpyXOgeQwK/1t4aNa4b2mi8wKAZNxus0aabLPo975GcnvZwciCSVVRTcC7s6qMHPcnCGD6VolRvkts1z8vX1+UBLthhngUixkYgHbkynjUsWm3XRnldk2aViiu/AUBBpRMmkO4utnhXVxWlytTwSBywY6AsiK2XUny67Si6RWNnRqJs4c/HyrWliomtk9lmA8InrwMePC6Qex49HPV7+oC7TJMQoxliJVPea5HXXsiVtsY5VOe7XzDAHXtghVilEESn7HTIJWQzZnqpPPM2/2Bh6gOqTKkdNnKZXJ8AMoWes3SXSb7AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-3",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 8 6"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAABHNCSVQICAgIfAhkiAAAAIhJREFUCJljYEAHr3YtYHi13wDGZUSRfHisgPEPU///v8wfGL6yKDIYGn5AKLh+XoHxD8uB/38YEhj/sk34/4fpP8N3FkcmuIIPvAv+f+SZwGCoe+D/ZzYHhs+8ggzfefZDJPc+K2DY+eIAinWrvhgwrvz5gYFh/XsDhnWfPzAs/66A4WAGBgYAa5oyFG6cdQcAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-4",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 11 13"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAABHNCSVQICAgIfAhkiAAAAThJREFUKJFtkL9Kw3AUhb/bpimISFa3dhAnIR10bp/Abg4ueYT6Bn0E36CdXRpBcSiaOAgiws9NEaGKulQ0cSk0obkOwWppznbP+e4fLhRIvs98ojOvKFvUx7Ar42FYFFkL1ThwSaWjU60BMAocsANYaVFvxKU5OAocJnaPqe1Rb8W56SBJVZjOAoxxZA4/XR+Klmu6sd1e2GaMI2Ur1Ew0h+9NU5S+TnFpNOKlY28eXQFjYYwjSaWnmXo0tpZBgLTS1oxL4fbBJ5OYnU2vEAzeXNAQLLdEYseS2LtcjdziqVafxPZorT/nxsWrL+fvEcHIWQBPP7ucfPm/Zf46WfU0sV+YrAUMorxhEDUlqXRIZX7e3+sGkYOW76AUIWmLtGrQ8gF7VX8ZBjhKXGYaohKhcsx+pfM//gFdM3pn6eP7BwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1112",
    "data-name": "Rectangle 1112",
    width: 489.673,
    height: 419.106,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 489.672,
    height: 419.106,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80100",
    "data-name": "Path 80100",
    d: "M0,1178.706,89.619,1235l111.5-27.635L111.5,1151.071Z",
    transform: "translate(-0.003 -1151.071)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80101",
    "data-name": "Path 80101",
    d: "M381.659,1418.453v49.179L493.154,1440v-49.179Z",
    transform: "translate(-381.659 -1390.818)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1.378,
    y1: 0.984,
    x2: -1.375,
    y2: 0.984,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80102",
    "data-name": "Path 80102",
    d: "M0,1317.943l89.616,56.294v-49.179L0,1268.764Z",
    transform: "translate(0 -1268.764)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80103",
    "data-name": "Path 80103",
    d: "M143.791,1212.341l62.41,39.2,61.076-15.171-62.41-39.2Z",
    transform: "translate(-143.791 -1197.17)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -0.556,
    y1: 1.325,
    x2: -0.553,
    y2: 1.325,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80104",
    "data-name": "Path 80104",
    d: "M409.583,1379.3v4.712l61.076-15.171v-4.712Z",
    transform: "translate(-409.583 -1364.128)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -5.768,
    y1: 1.952,
    x2: -5.757,
    y2: 1.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80105",
    "data-name": "Path 80105",
    d: "M143.791,1266.494l62.41,39.2v-4.712l-62.41-39.2Z",
    transform: "translate(-143.791 -1261.782)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.433,
    y1: 1.826,
    x2: -0.43,
    y2: 1.826,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80106",
    "data-name": "Path 80106",
    d: "M405.626,936.253l3.236,58.657,58.77,40.75,3.016-1.4V974.221l-61.785-39.354Z",
    transform: "translate(-405.626 -934.867)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.681,
    y1: 1.744,
    x2: -0.679,
    y2: 1.744,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80108",
    "data-name": "Path 80108",
    d: "M405.626,1000.812l61.785,39.354V980.123l-61.785-39.354Z",
    transform: "translate(-405.626 -940.769)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -1.542,
    y1: 1.507,
    x2: -1.538,
    y2: 1.507,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80130",
    "data-name": "Path 80130",
    d: "M431.91,1017.651l1.937,2.977,3.587,2.317,1.4,4.928,3.525,3.113,2.32,3.649,2.029,2.72,3.237,2.381,1.685,2.747,1.8.786,1.456,2.153.485-.269-1.738-2.569-1.761-.769-1.591-2.592-3.308-2.434-1.822-2.439-2.424-3.818-3.314-2.927-1.437-5.071-3.838-2.479-1.72-2.645Z",
    transform: "translate(-431.91 -1017.412)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80149",
    "data-name": "Path 80149",
    d: "M278.614,1231.521l47.871,30.071,29.579-7.347-47.87-30.071Z",
    transform: "translate(-278.614 -1224.174)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -1.239,
    y1: 1.824,
    x2: -1.235,
    y2: 1.824,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80151",
    "data-name": "Path 80151",
    d: "M646.8,120.827h-.015c-.066,0-.133.009-.2.012-.327.013-.657.031-.988.059l-.1.006c-.112.009-.225.027-.337.038-.258.026-.516.053-.775.087-.057.008-.113.012-.17.02-.106.015-.214.036-.32.053-.242.037-.485.076-.728.121-.078.014-.155.024-.234.039q-.314.06-.63.128l-.133.031c-.12.029-.24.062-.36.095l28.016,16.7c.164-.045.328-.09.493-.126.29-.063.578-.115.866-.168.242-.044.483-.083.724-.12.165-.025.33-.051.495-.073.259-.034.515-.062.773-.087.147-.015.294-.032.44-.044.331-.028.659-.046.987-.059.074,0,.148-.01.222-.012q.614-.019,1.219-.005c.108,0,.213.009.32.013.311.011.621.026.929.05.134.01.268.023.4.036.323.03.645.068.964.112.117.016.234.03.35.048.441.068.88.147,1.313.241l.186.044q.725.163,1.434.374c.069.021.139.039.208.06.594.183,1.177.393,1.752.624.075.03.15.058.224.089.378.156.752.321,1.121.5.042.02.082.042.123.062q.494.24.976.5c.25.137.5.275.746.422L659.074,124h0q-.308-.183-.62-.356c-.041-.023-.084-.042-.125-.065q-.483-.264-.976-.505c-.041-.02-.081-.042-.123-.062-.369-.177-.743-.341-1.12-.5-.033-.014-.065-.03-.1-.044s-.085-.028-.126-.045c-.575-.231-1.159-.441-1.752-.623-.02-.006-.039-.015-.06-.021-.049-.015-.1-.024-.149-.039q-.708-.21-1.431-.374c-.044-.01-.086-.024-.13-.034l-.059-.011q-.65-.14-1.313-.24l-.112-.021c-.079-.012-.16-.017-.239-.027q-.478-.066-.961-.112c-.077-.007-.152-.02-.23-.026-.058-.005-.117-.005-.175-.009-.307-.024-.617-.039-.928-.05-.084,0-.166-.011-.25-.013h-.07q-.256-.006-.514-.006-.353,0-.713.011",
    transform: "translate(-641.808 -120.816)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c4353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#556575"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80158",
    "data-name": "Path 80158",
    d: "M305.208,71.7c-14.4,3.12-26.657,18.256-30.928,36.416a16.9,16.9,0,0,0-12.271-1.825c-13.291,2.881-24.149,19.5-24.253,37.125,0,.455.012.906.019,1.359a17.662,17.662,0,0,0-6.962.146c-13.282,2.879-24.14,19.5-24.244,37.123s10.585,29.574,23.867,26.7l5.71-1.238,99.992-21.672,3.376-.9c16.55-5.433,29.658-26.629,29.791-49.054.14-23.644-14.2-39.675-32.032-35.81-.164.035-.328.081-.493.126-2.251-17.336-12.854-29.068-26.338-29.069a24.658,24.658,0,0,0-5.236.574",
    transform: "translate(-206.568 -71.126)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -0.297,
    y1: 2.864,
    x2: -0.295,
    y2: 2.864,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80160",
    "data-name": "Path 80160",
    d: "M690.078,117.191l.654,4.939,4.9-1.337c.019-.005.03-.012.049-.018-1.556-10.954-6.878-19.409-14.122-22.92,4.387,4.49,7.465,11.258,8.516,19.336",
    transform: "translate(-681.562 -97.855)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -6.443,
    y1: 13.685,
    x2: -6.434,
    y2: 13.685,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80162",
    "data-name": "Path 80162",
    d: "M391.841,244.714c-.124,20.152-11.728,39.738-26.454,44.657l-3.136.83-105.6,22.888a13.047,13.047,0,0,1-5.1.132,11.347,11.347,0,0,1-2.2-.621,13.437,13.437,0,0,0,7.9,4.787,13.213,13.213,0,0,0,5.1-.133l105.6-22.888,3.138-.838c14.726-4.919,26.328-24.5,26.454-44.657.08-14.3-5.729-25.936-14.6-30.23,5.58,5.734,8.971,15.125,8.906,26.073",
    transform: "translate(-249.353 -218.641)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.203,
    y1: 2.622,
    x2: -0.201,
    y2: 2.622,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80164",
    "data-name": "Path 80164",
    d: "M320.735,90.635a21.984,21.984,0,0,0-2.267.618c-11.283,3.725-21.406,16.606-25.094,32.315l-1.429,6.074-5.329-3.077a12.348,12.348,0,0,0-4-1.472,12.994,12.994,0,0,0-5.077.136c-11.055,2.4-20.474,17.348-20.563,32.638,0,.273,0,.54.01.815l.093,6.072-5.558-1.009a13.13,13.13,0,0,0-5.173.11c-11.055,2.4-20.474,17.347-20.563,32.638-.039,7.336,2.048,13.68,5.534,17.8a11.345,11.345,0,0,0,2.2.621,13.047,13.047,0,0,0,5.1-.132l105.6-22.888,3.136-.83c8.264-2.755,15.543-10.143,20.367-19.649a56.742,56.742,0,0,0,6.086-25.008c.064-10.948-3.327-20.338-8.906-26.073a18.417,18.417,0,0,0-17.781-5.489,1.141,1.141,0,0,0-.193.048c-.02.006-.03.013-.05.018l-4.9,1.337-.654-4.939c-1.05-8.078-4.128-14.846-8.515-19.336a17.191,17.191,0,0,0-4.632-1.529,18.005,18.005,0,0,0-3.163-.276,20.291,20.291,0,0,0-4.272.467",
    transform: "translate(-225.782 -90.168)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.008,
    y1: 1.852,
    x2: 0.009,
    y2: 1.852,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1055",
    "data-name": "Rectangle 1055",
    width: 61.257,
    height: 82.319,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80166",
    "data-name": "Path 80166",
    d: "M515.806,1495.274v21.394l48.5-12.022v-21.395Z",
    transform: "translate(-515.806 -1483.252)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1.998,
    y1: 1.558,
    x2: -1.994,
    y2: 1.558,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80167",
    "data-name": "Path 80167",
    d: "M689.07,1485.19v16.749l7.821,2.707v-21.395Z",
    transform: "translate(-689.07 -1483.252)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -20.687,
    y1: 3.311,
    x2: -20.657,
    y2: 3.311,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333131"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80168",
    "data-name": "Path 80168",
    d: "M90.1,1218.052v4.725l48.5-12.022-7.821-2.708Z",
    transform: "translate(-90.102 -1208.048)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -0.436,
    y1: 9.196,
    x2: -0.431,
    y2: 9.196,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80170",
    "data-name": "Path 80170",
    d: "M1086.211,1181.971c0,23.144,52.51,41.915,117.3,41.915,62.57,0,113.694-17.509,117.124-39.551v-30.08c-3.43,22.042-54.554,39.551-117.124,39.551-64.793,0-117.3-18.771-117.3-41.915Z",
    transform: "translate(-1086.211 -1151.891)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -1.088,
    y1: 2.065,
    x2: -1.087,
    y2: 2.065,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80171",
    "data-name": "Path 80171",
    d: "M1086.211,1012.087c0,23.144,52.51,41.916,117.3,41.916,62.57,0,113.694-17.509,117.124-39.551a13.122,13.122,0,0,0,.2-2.364c0-23.144-52.528-41.9-117.32-41.9s-117.3,18.754-117.3,41.9",
    transform: "translate(-1086.211 -970.189)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80172",
    "data-name": "Path 80172",
    d: "M1086.214,1178.7c0,23.147,52.51,41.913,117.3,41.913,5.316,0,10.562-.13,15.688-.38,55.233-2.628,98.307-19,101.444-39.166v-30.083c-3.41,21.88-53.788,39.285-115.723,39.546h-1.409c-64.787,0-117.3-18.767-117.3-41.914Z",
    transform: "translate(-1086.214 -1148.616)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80173",
    "data-name": "Path 80173",
    d: "M1086.211,1147.446c0,23.144,52.51,41.916,117.3,41.916,62.57,0,113.694-17.51,117.124-39.551a13.118,13.118,0,0,0,.2-2.364c0-.084-.017-.167-.018-.251a12.475,12.475,0,0,1-.178,1.891c-3.43,22.043-54.554,39.551-117.124,39.551-64.454,0-116.731-18.576-117.278-41.553,0,.122-.025.241-.025.362",
    transform: "translate(-1086.211 -1147.084)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80174",
    "data-name": "Path 80174",
    d: "M1241.7,973.42c0,15.941,36.168,28.871,80.8,28.871,43.1,0,78.31-12.06,80.672-27.242V926.928c-2.363,15.182-37.575,27.242-80.672,27.242-44.628,0-80.8-12.929-80.8-28.871Z",
    transform: "translate(-1241.701 -925.299)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -1.806,
    y1: 2.622,
    x2: -1.804,
    y2: 2.622,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80175",
    "data-name": "Path 80175",
    d: "M1241.7,829.005c0,15.941,36.167,28.871,80.8,28.871,43.1,0,78.309-12.06,80.672-27.242a9.027,9.027,0,0,0,.135-1.629c0-15.941-36.18-28.858-80.807-28.859s-80.8,12.917-80.8,28.858",
    transform: "translate(-1241.701 -800.147)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80176",
    "data-name": "Path 80176",
    d: "M1241.7,971.17c0,4.8,3.27,9.313,9.052,13.284,13.456,9.264,40.53,15.585,71.74,15.585,43.1,0,78.313-12.061,80.678-27.238V924.678c-2.365,15.177-37.578,27.238-80.678,27.238-7.364,0-14.491-.351-21.268-1.012-34.3-3.335-59.524-14.54-59.524-27.857Z",
    transform: "translate(-1241.703 -923.047)",
    fill: "#12151c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80177",
    "data-name": "Path 80177",
    d: "M1789.274,1070.661v7.785c2.147-.548,4.2-1.142,6.131-1.78v-7.785c-1.935.638-3.984,1.232-6.131,1.78",
    transform: "translate(-1789.274 -1068.881)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80178",
    "data-name": "Path 80178",
    d: "M1827.56,1055.87v7.785a58.489,58.489,0,0,0,6.131-2.678v-7.785a58.336,58.336,0,0,1-6.131,2.678",
    transform: "translate(-1827.56 -1053.192)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80179",
    "data-name": "Path 80179",
    d: "M1750.986,1080.637v7.785q3.169-.552,6.131-1.224v-7.784q-2.958.671-6.131,1.224",
    transform: "translate(-1750.986 -1079.413)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80180",
    "data-name": "Path 80180",
    d: "M1865.845,1029.369v7.785a22.956,22.956,0,0,0,6.132-5.219v-7.784a22.972,22.972,0,0,1-6.132,5.218",
    transform: "translate(-1865.845 -1024.151)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80181",
    "data-name": "Path 80181",
    d: "M1712.742,1087.408v7.784q3.136-.346,6.122-.806V1086.6q-2.986.456-6.122.805",
    transform: "translate(-1712.742 -1086.603)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80182",
    "data-name": "Path 80182",
    d: "M1789.274,1117.551v7.785c2.147-.548,4.2-1.142,6.131-1.78v-7.784c-1.935.638-3.984,1.232-6.131,1.78",
    transform: "translate(-1789.274 -1115.771)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80183",
    "data-name": "Path 80183",
    d: "M1827.56,1102.761v7.785a58.413,58.413,0,0,0,6.131-2.678v-7.784a58.438,58.438,0,0,1-6.131,2.678",
    transform: "translate(-1827.56 -1100.083)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80184",
    "data-name": "Path 80184",
    d: "M1750.986,1127.527v7.785q3.169-.552,6.131-1.224V1126.3q-2.958.671-6.131,1.224",
    transform: "translate(-1750.986 -1126.303)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80185",
    "data-name": "Path 80185",
    d: "M1865.845,1076.259v7.785a22.959,22.959,0,0,0,6.132-5.219v-7.784a22.972,22.972,0,0,1-6.132,5.218",
    transform: "translate(-1865.845 -1071.041)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80186",
    "data-name": "Path 80186",
    d: "M1712.742,1134.3v7.785q3.136-.346,6.122-.806v-7.784q-2.986.456-6.122.805",
    transform: "translate(-1712.742 -1133.493)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80187",
    "data-name": "Path 80187",
    d: "M1241.7,922.237c0,15.941,36.167,28.871,80.8,28.871,43.1,0,78.309-12.06,80.672-27.242a9.027,9.027,0,0,0,.135-1.629c0-.058-.011-.115-.013-.173a8.535,8.535,0,0,1-.123,1.3c-2.363,15.183-37.575,27.242-80.672,27.242-44.394,0-80.4-12.795-80.778-28.621,0,.084-.018.166-.018.249",
    transform: "translate(-1241.701 -921.988)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80188",
    "data-name": "Path 80188",
    d: "M1241.7,742.09c0,15.942,36.167,28.871,80.8,28.871,43.1,0,78.309-12.06,80.672-27.242V695.6c-2.363,15.182-37.575,27.242-80.672,27.242-44.628,0-80.8-12.93-80.8-28.871Z",
    transform: "translate(-1241.701 -693.969)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -1.806,
    y1: 3.327,
    x2: -1.804,
    y2: 3.327,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80189",
    "data-name": "Path 80189",
    d: "M1241.7,597.675c0,15.941,36.167,28.87,80.8,28.871,43.1,0,78.309-12.06,80.672-27.242a9.027,9.027,0,0,0,.135-1.628c0-15.941-36.18-28.859-80.807-28.859s-80.8,12.917-80.8,28.859",
    transform: "translate(-1241.701 -568.816)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80190",
    "data-name": "Path 80190",
    d: "M1241.7,739.826c0,13.872,27.385,25.46,63.895,28.233,5.448.416,11.1.636,16.9.636,43.1,0,78.313-12.053,80.678-27.238V693.334c-2.275,14.6-34.887,26.3-75.687,27.189q-2.471.061-4.991.057c-44.624,0-80.792-12.934-80.792-28.877Z",
    transform: "translate(-1241.703 -691.703)",
    fill: "#12151c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80191",
    "data-name": "Path 80191",
    d: "M1789.274,839.33v7.784c2.147-.548,4.2-1.142,6.131-1.78V837.55c-1.935.639-3.984,1.232-6.131,1.78",
    transform: "translate(-1789.274 -837.55)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80192",
    "data-name": "Path 80192",
    d: "M1827.559,824.54v7.784a58.353,58.353,0,0,0,6.132-2.678v-7.785a58.451,58.451,0,0,1-6.132,2.678",
    transform: "translate(-1827.559 -821.862)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80193",
    "data-name": "Path 80193",
    d: "M1750.986,849.306v7.785q3.169-.552,6.131-1.224v-7.785q-2.958.671-6.131,1.224",
    transform: "translate(-1750.986 -848.082)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80194",
    "data-name": "Path 80194",
    d: "M1865.845,798.039v7.784a22.963,22.963,0,0,0,6.132-5.219V792.82a22.969,22.969,0,0,1-6.132,5.219",
    transform: "translate(-1865.845 -792.82)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80195",
    "data-name": "Path 80195",
    d: "M1712.742,856.078v7.785q3.136-.346,6.122-.806v-7.784q-2.986.455-6.122.805",
    transform: "translate(-1712.742 -855.273)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80196",
    "data-name": "Path 80196",
    d: "M1789.274,886.221v7.785c2.147-.548,4.2-1.142,6.131-1.78v-7.784c-1.935.638-3.984,1.232-6.131,1.78",
    transform: "translate(-1789.274 -884.441)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80197",
    "data-name": "Path 80197",
    d: "M1827.559,871.43v7.785a58.4,58.4,0,0,0,6.132-2.678v-7.785a58.327,58.327,0,0,1-6.132,2.678",
    transform: "translate(-1827.559 -868.752)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80198",
    "data-name": "Path 80198",
    d: "M1750.986,896.2v7.785q3.169-.552,6.131-1.224v-7.784q-2.958.671-6.131,1.224",
    transform: "translate(-1750.986 -894.973)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80199",
    "data-name": "Path 80199",
    d: "M1865.845,844.929v7.785a22.961,22.961,0,0,0,6.132-5.219v-7.784a22.971,22.971,0,0,1-6.132,5.218",
    transform: "translate(-1865.845 -839.711)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80200",
    "data-name": "Path 80200",
    d: "M1712.742,902.969v7.784q3.136-.346,6.122-.806v-7.784q-2.986.455-6.122.806",
    transform: "translate(-1712.742 -902.163)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80201",
    "data-name": "Path 80201",
    d: "M1241.7,690.907c0,15.941,36.167,28.87,80.8,28.871,43.1,0,78.309-12.06,80.672-27.242a9.03,9.03,0,0,0,.135-1.629c0-.058-.011-.115-.012-.173a8.61,8.61,0,0,1-.123,1.3c-2.363,15.182-37.575,27.242-80.672,27.242-44.394,0-80.4-12.8-80.778-28.622,0,.084-.018.166-.018.249",
    transform: "translate(-1241.701 -690.658)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80202",
    "data-name": "Path 80202",
    d: "M1241.7,510.759c0,15.941,36.167,28.871,80.8,28.871,43.1,0,78.309-12.06,80.672-27.242V464.267c-2.363,15.182-37.575,27.242-80.672,27.242-44.628,0-80.8-12.929-80.8-28.871Z",
    transform: "translate(-1241.7 -462.638)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -1.806,
    y1: 4.033,
    x2: -1.804,
    y2: 4.033,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80203",
    "data-name": "Path 80203",
    d: "M1241.7,366.345c0,15.941,36.168,28.871,80.8,28.871,43.1,0,78.309-12.06,80.672-27.242a9.025,9.025,0,0,0,.135-1.628c0-15.941-36.18-28.859-80.807-28.859s-80.8,12.917-80.8,28.858",
    transform: "translate(-1241.7 -337.487)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80204",
    "data-name": "Path 80204",
    d: "M1241.7,508.519c0,15.935,36.167,28.869,80.792,28.869q3.3,0,6.549-.1c40.066-1.142,71.887-12.738,74.129-27.148V462.027c-2.161,13.847-31.658,25.1-69.554,26.96q-5.456.282-11.124.277c-44.624,0-80.792-12.926-80.792-28.869Z",
    transform: "translate(-1241.702 -460.396)",
    fill: "#12151c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80205",
    "data-name": "Path 80205",
    d: "M1789.273,608v7.785c2.147-.548,4.2-1.141,6.131-1.78V606.22c-1.935.638-3.984,1.232-6.131,1.78",
    transform: "translate(-1789.273 -606.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80206",
    "data-name": "Path 80206",
    d: "M1827.559,593.21v7.785a58.426,58.426,0,0,0,6.132-2.678v-7.785a58.362,58.362,0,0,1-6.132,2.678",
    transform: "translate(-1827.559 -590.532)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80207",
    "data-name": "Path 80207",
    d: "M1750.986,617.976v7.785q3.169-.552,6.131-1.224v-7.785q-2.958.671-6.131,1.224",
    transform: "translate(-1750.986 -616.752)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80208",
    "data-name": "Path 80208",
    d: "M1865.844,566.708v7.785a22.969,22.969,0,0,0,6.132-5.219V561.49a22.976,22.976,0,0,1-6.132,5.218",
    transform: "translate(-1865.844 -561.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80209",
    "data-name": "Path 80209",
    d: "M1712.742,624.748v7.784q3.135-.346,6.122-.806v-7.784q-2.987.456-6.122.806",
    transform: "translate(-1712.742 -623.942)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80210",
    "data-name": "Path 80210",
    d: "M1789.274,654.89v7.784c2.147-.548,4.2-1.142,6.131-1.78V653.11c-1.935.638-3.984,1.232-6.131,1.78",
    transform: "translate(-1789.274 -653.11)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80211",
    "data-name": "Path 80211",
    d: "M1827.559,640.1v7.785a58.451,58.451,0,0,0,6.132-2.678v-7.785a58.35,58.35,0,0,1-6.132,2.678",
    transform: "translate(-1827.559 -637.422)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80212",
    "data-name": "Path 80212",
    d: "M1750.986,664.866v7.785q3.169-.552,6.131-1.224v-7.784q-2.958.671-6.131,1.224",
    transform: "translate(-1750.986 -663.642)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80213",
    "data-name": "Path 80213",
    d: "M1865.844,613.6v7.784a22.962,22.962,0,0,0,6.132-5.219V608.38a22.976,22.976,0,0,1-6.132,5.219",
    transform: "translate(-1865.844 -608.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80214",
    "data-name": "Path 80214",
    d: "M1712.742,671.638v7.785q3.136-.346,6.122-.806v-7.784q-2.987.456-6.122.806",
    transform: "translate(-1712.742 -670.832)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80215",
    "data-name": "Path 80215",
    d: "M1241.7,459.576c0,15.941,36.168,28.871,80.8,28.871,43.1,0,78.309-12.06,80.672-27.242a9.025,9.025,0,0,0,.135-1.628c0-.058-.011-.115-.012-.173a8.6,8.6,0,0,1-.123,1.3c-2.363,15.183-37.575,27.242-80.672,27.242-44.395,0-80.4-12.795-80.779-28.621,0,.084-.017.166-.017.249",
    transform: "translate(-1241.7 -459.327)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 59.523,
    height: 61.408,
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 85.784,
    height: 76.357,
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 92.037,
    height: 76.991,
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80219",
    "data-name": "Path 80219",
    d: "M1388.822,406.563c0,9.126,20.7,16.527,46.253,16.528,24.672,0,44.83-6.9,46.183-15.6a5.167,5.167,0,0,0,.077-.932c0-9.126-20.712-16.521-46.26-16.521s-46.253,7.395-46.253,16.521",
    transform: "translate(-1388.822 -390.042)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80942",
    "data-name": "Path 80942",
    d: "M5.513,3.3.189,11l3.077,3.468.758-1.1-2.391-2.7,4.556-6.6L9,7.171l.692.765.765-1.106,3.1-4.491,4.192,4.585-2.68,3.9.7.775,3.457-5.021-4.91-5.353-1.443.342-3.108,4.5L6.942,2.957Z",
    transform: "translate(0)",
    fill: "url(#pattern)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-5",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 15"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAPCAYAAAAGRPQsAAAABHNCSVQICAgIfAhkiAAAAaFJREFUOI2lk7+KFEEQh7+q6vVWVFwF8Q1EEBMDRTjnokvU9/F5TAWfYhZBNNHQM5bLBMXg1q4qg+ndmbk9OcGGpviq61f8+p/wP+N13gO67Sz/LMwU3v56SGhHWIdbh+ddUnYl8lfxmzRunz4iOSJKR9VDCbuVVZAopAuEQdUhpkyanZwc8GPzmFh0uByJ29N0vS5hpCu4gTfhNE7ywpf3LyTLq6z6RMKupCsSRtYW93jrbJsXiAIuFA7qMTWeiRp4IKqkOzOOgdMDTEmPxg6tDjMKi80SLUOBxeDAbM5hpDb2tl5jUjdw0YWvUhMxbU6aI7M9Hh1tdxBIc4oqJRab1SBUsCCrt0YOVnac3uKOdXSuQapSRHOJVtC5M3R0llOHOm7tPJfMvCoioDHMGA6TOsTxTByxMmctpLZ8ja9FRG7OHuu2qSrsbtVnzogIUf2UnmtM+kR6Htw/LZks5aJ/sGsaUOwsa3xQK338jjXL6Llz+PO8pIiwvKDVd+Bdkj2Wa27Uj8jzs7jk+xZghci3jOxVZR3iPddefkYkL9HujT9EsR5+tn25WwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80943",
    "data-name": "Path 80943",
    d: "M5.567,1.561l4.942,5.35L5.9,13.613,1.691,8.966,4.379,5.088l-.707-.758L.959,8.268.247,9.3l.635.7L5.14,14.737,6.6,14.4l5.371-7.832L7.03,1.215Z",
    fill: "url(#pattern-2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-6",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 15"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAABHNCSVQICAgIfAhkiAAAAJlJREFUKJG10jEOAXEUxOHvv7uFRCQKd5AodRJ7DrXKEdxGo3MAR1iNxCVcQRCJp0BCY63EtDO/zHvJJHVaxECuFEpJmd7MVeQOhrK7KYzRe40ky+gLE6HECO1PhYWrKea1pz2Uoftt+Am0/gmcmwHh1AzI7sD3TzduSE2BXxoKdGpiR2Ers8G6ENreJ7hHJdkIlZOdWbo8zRvesiWTym1BCgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80944",
    "data-name": "Path 80944",
    d: "M3.879,2.142,0,7.779l1.443-.331L4.571,2.912l2.86,3.181L8.886,5.76,5.335,1.8l-.693-.771Z",
    transform: "translate(0 0)",
    fill: "url(#pattern-3)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-7",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 9 7"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAABHNCSVQICAgIfAhkiAAAAG1JREFUGJV9zLEJAlEURNHz1g2+GKylGCn8bcembMEOLGAxMLUOMVIE8Zktorg3nLkz4Zt9ztyshIpeqmGXnaIKVeqxxuJz1yoO2Mifz5EGy/81eDQok0q6NphPSuHcSp0Yg7t0EgYvg6ejbVzeOP4XdtKFUEMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80945",
    "data-name": "Path 80945",
    d: "M5.626,1.534.306,9.227l4.755,5.416,1.439-.33,4.641-6.742.713-1.035-.631-.7L8.765,3.1,8,4.2l2.419,2.67L5.821,13.526,1.729,8.895l5.338-7.7Z",
    fill: "url(#pattern-4)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-8",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 15"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAABHNCSVQICAgIfAhkiAAAALNJREFUKJGV0jFOAlEUheHvPcbERkJCQWFpQcUKjLMCWAFxL3YsxNKSTTiVFS0boJDKjCZyKYAEG+fNbc/5c/+b3KRrXmMq1EKNOv0JXyJ7MHM4hcKTZHJdSb7W997mz6jxiOF/Cyu/eYFVpxqE7yyMisonnzb7HJUDoc0209tiINtnu3E5ENpM3xv6AOcN5Ur6A/t+SrQV7jpKOzRCY2BdCWOXF0x+hA9J4+DdjcYyba/pI1NfLXBnrea5AAAAAElFTkSuQmCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39894",
    "data-name": "Group 39894",
    transform: "translate(-1298.278 -446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39688",
    "data-name": "Group 39688",
    transform: "translate(1298.278 446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39687",
    "data-name": "Group 39687",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39506",
    "data-name": "Group 39506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39505",
    "data-name": "Group 39505",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80098",
    "data-name": "Path 80098",
    d: "M263.819,584.389V631.4a11.578,11.578,0,0,1-9.017,11.291L223.019,649.9a12.4,12.4,0,0,0-9.657,12.092v71.194",
    transform: "translate(-163.263 -447.171)",
    fill: "none",
    stroke: "#14e2c5",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80099",
    "data-name": "Path 80099",
    d: "M652.175,565.187v33.139a11.076,11.076,0,0,0,13.713,10.757l68.651-16.829a9.5,9.5,0,0,1,11.757,9.224v29.344",
    transform: "translate(-499.04 -432.477)",
    fill: "none",
    stroke: "#14e2c5",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y2: 151.897,
    transform: "translate(128.229 130.459)",
    fill: "none",
    stroke: "#14e2c5",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39508",
    "data-name": "Group 39508",
    transform: "translate(0.001 270.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39507",
    "data-name": "Group 39507",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 142.942,
    height: 217.304,
    transform: "matrix(0.315, -0.949, 0.949, 0.315, -25.065, 75.621)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39510",
    "data-name": "Group 39510",
    transform: "translate(89.616 326.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39509",
    "data-name": "Group 39509",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 77.419,
    height: 111.911,
    transform: "matrix(0.005, -1, 1, 0.005, -0.417, 76.812)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39512",
    "data-name": "Group 39512",
    transform: "translate(0 297.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39511",
    "data-name": "Group 39511",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 136.428,
    height: 130.873,
    transform: "translate(-46.266 78.048) rotate(-59.341)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39514",
    "data-name": "Group 39514",
    transform: "translate(33.763 281.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39513",
    "data-name": "Group 39513",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    width: 90.465,
    height: 134.322,
    transform: "matrix(0.315, -0.949, 0.949, 0.315, -16.239, 48.992)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39516",
    "data-name": "Group 39516",
    transform: "translate(96.173 320.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39515",
    "data-name": "Group 39515",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 20.215,
    height: 61.183,
    transform: "translate(-0.108 19.883) rotate(-89.689)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39518",
    "data-name": "Group 39518",
    transform: "translate(33.763 296.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39517",
    "data-name": "Group 39517",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    width: 69.601,
    height: 76.079,
    transform: "translate(-19.263 32.496) rotate(-59.341)",
    fill: "url(#linear-gradient-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39520",
    "data-name": "Group 39520",
    transform: "translate(95.244 219.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39519",
    "data-name": "Group 39519",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    width: 108.201,
    height: 119.919,
    transform: "matrix(0.852, -0.524, 0.524, 0.852, -44.989, 27.686)",
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39522",
    "data-name": "Group 39522",
    transform: "translate(95.244 220.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39521",
    "data-name": "Group 39521",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80107",
    "data-name": "Path 80107",
    d: "M467.411,862.425l-61.785-24.041V961.821l61.785,24.041Z",
    transform: "translate(-405.626 -862.425)",
    fill: "url(#linear-gradient-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39524",
    "data-name": "Group 39524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39523",
    "data-name": "Group 39523",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80109",
    "data-name": "Path 80109",
    d: "M472.577,1018.75l-57.212-36.441v49.39l57.212,36.44Z",
    transform: "translate(-317.835 -751.656)",
    fill: "#12151c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39534",
    "data-name": "Group 39534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39533",
    "data-name": "Group 39533",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80118",
    "data-name": "Path 80118",
    d: "M432.447,1012.926l23.216,15v17.88l-23.216-15Zm22.963,15.085-22.711-14.67v17.375l22.711,14.67Z",
    transform: "translate(-330.906 -775.084)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80119",
    "data-name": "Path 80119",
    d: "M512.821,1083.008l.252.163v-17.628l-.252-.163Z",
    transform: "translate(-392.407 -815.222)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80120",
    "data-name": "Path 80120",
    d: "M496.771,1072.64l.252.163v-17.628l-.252-.163Z",
    transform: "translate(-380.126 -807.289)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80121",
    "data-name": "Path 80121",
    d: "M480.716,1062.27l.252.163v-17.628l-.252-.163Z",
    transform: "translate(-367.841 -799.353)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80122",
    "data-name": "Path 80122",
    d: "M464.662,1051.9l.252.163v-17.628l-.252-.163Z",
    transform: "translate(-355.556 -791.418)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80123",
    "data-name": "Path 80123",
    d: "M448.611,1041.532l.252.163v-17.628l-.252-.163Z",
    transform: "translate(-343.274 -783.485)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80124",
    "data-name": "Path 80124",
    d: "M432.985,1024.578l22.963,14.833v-.252l-22.963-14.833Z",
    transform: "translate(-331.317 -783.807)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80125",
    "data-name": "Path 80125",
    d: "M432.985,1037.74l22.963,14.833v-.252l-22.963-14.833Z",
    transform: "translate(-331.317 -793.878)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80126",
    "data-name": "Path 80126",
    d: "M432.985,1050.9l22.963,14.833v-.252l-22.963-14.833Z",
    transform: "translate(-331.317 -803.95)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80127",
    "data-name": "Path 80127",
    d: "M432.985,1064.065l22.963,14.833v-.252l-22.963-14.833Z",
    transform: "translate(-331.317 -814.022)",
    fill: "#a09797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80128",
    "data-name": "Path 80128",
    d: "M432.985,1077.228l22.963,14.833v-.252l-22.963-14.833Z",
    transform: "translate(-331.317 -824.095)",
    fill: "#a09797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39536",
    "data-name": "Group 39536",
    transform: "translate(101.415 238.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39535",
    "data-name": "Group 39535",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80129",
    "data-name": "Path 80129",
    d: "M455.368,968.036,431.91,952.884v43.162l23.458,15.152Z",
    transform: "translate(-431.91 -968.036)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39550",
    "data-name": "Group 39550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39549",
    "data-name": "Group 39549",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80143",
    "data-name": "Path 80143",
    d: "M456.583,1129.643l15.7,10.142c.234.151.425.083.425-.15a.964.964,0,0,0-.425-.7l-15.7-10.142c-.234-.151-.425-.083-.425.151a.963.963,0,0,0,.425.7",
    transform: "translate(-349.049 -863.683)",
    fill: "#c4c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80144",
    "data-name": "Path 80144",
    d: "M438.753,1128.462l19.887,12.846c.234.151.425.083.425-.15a.963.963,0,0,0-.425-.7l-19.887-12.846c-.234-.151-.425-.083-.425.15a.963.963,0,0,0,.425.7",
    transform: "translate(-335.406 -862.78)",
    fill: "#c4c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80145",
    "data-name": "Path 80145",
    d: "M438.753,1138.8l19.887,12.846c.234.151.425.083.425-.15a.963.963,0,0,0-.425-.7l-19.887-12.846c-.234-.151-.425-.083-.425.15a.963.963,0,0,0,.425.7",
    transform: "translate(-335.406 -870.689)",
    fill: "#c4c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80146",
    "data-name": "Path 80146",
    d: "M438.753,1149.134l19.887,12.846c.234.151.425.083.425-.15a.964.964,0,0,0-.425-.7l-19.887-12.846c-.234-.151-.425-.083-.425.151a.962.962,0,0,0,.425.7",
    transform: "translate(-335.406 -878.598)",
    fill: "#c4c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80147",
    "data-name": "Path 80147",
    d: "M438.753,1159.47l19.887,12.846c.234.151.425.083.425-.151a.964.964,0,0,0-.425-.7l-19.887-12.846c-.234-.151-.425-.083-.425.151a.963.963,0,0,0,.425.7",
    transform: "translate(-335.406 -886.507)",
    fill: "#c4c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80148",
    "data-name": "Path 80148",
    d: "M438.753,1169.806l16.8,10.851c.234.151.425.083.425-.15a.962.962,0,0,0-.425-.7l-16.8-10.852c-.234-.151-.425-.083-.425.15a.963.963,0,0,0,.425.7",
    transform: "translate(-335.406 -894.416)",
    fill: "#c4c0c0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39552",
    "data-name": "Group 39552",
    transform: "translate(65.42 287.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39551",
    "data-name": "Group 39551",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1053",
    "data-name": "Rectangle 1053",
    width: 59.888,
    height: 85.288,
    transform: "matrix(0.315, -0.949, 0.949, 0.315, -11.176, 33.713)",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39554",
    "data-name": "Group 39554",
    transform: "translate(150.701 28.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39553",
    "data-name": "Group 39553",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80150",
    "data-name": "Path 80150",
    d: "M626.829,106.755,673,89.381l-11.58-32.565L615.249,74.19Z",
    transform: "translate(-621.485 -71.843)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39562",
    "data-name": "Group 39562",
    transform: "translate(48.503 16.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39561",
    "data-name": "Group 39561",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 163.014,
    height: 140.504,
    transform: "translate(-0.12 -0.006)",
    fill: "url(#linear-gradient-19)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39564",
    "data-name": "Group 39564",
    transform: "translate(160.035 22.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39563",
    "data-name": "Group 39563",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80159",
    "data-name": "Path 80159",
    d: "M684.453,90.839l-18.578-3.311-5.487,25.814,18.578,3.311Z",
    transform: "translate(-665.359 -89.953)",
    fill: "url(#linear-gradient-20)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39566",
    "data-name": "Group 39566",
    transform: "translate(58.55 51.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39565",
    "data-name": "Group 39565",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80161",
    "data-name": "Path 80161",
    d: "M351.8,139.294,188.661,110.222l-25.7,120.88L326.1,260.174Z",
    transform: "translate(-183.249 -135.679)",
    fill: "url(#linear-gradient-21)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39568",
    "data-name": "Group 39568",
    transform: "translate(53.015 21.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39567",
    "data-name": "Group 39567",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80163",
    "data-name": "Path 80163",
    d: "M-8.6-15.269,158.913,76.29,249.519-80.187,82.009-171.746Z",
    transform: "translate(-46.437 110.247)",
    fill: "url(#linear-gradient-22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39573",
    "data-name": "Group 39573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39572",
    "data-name": "Group 39572",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39571",
    "data-name": "Group 39571",
    transform: "translate(139.782 21.173)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39570",
    "data-name": "Group 39570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39569",
    "data-name": "Group 39569",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80165",
    "data-name": "Path 80165",
    d: "M596.859,104.905c-6.834,32.144,9.539,62.1,36.57,66.923a43.147,43.147,0,0,0,17.048-.413,56.747,56.747,0,0,0,6.086-25.008c.064-10.948-3.327-20.338-8.906-26.073a18.416,18.416,0,0,0-17.781-5.489,1.151,1.151,0,0,0-.193.047c-.02.006-.03.013-.049.019l-4.9,1.337-.654-4.939c-1.05-8.078-4.128-14.846-8.516-19.336a17.179,17.179,0,0,0-4.632-1.529,19.191,19.191,0,0,0-7.435.191,21.984,21.984,0,0,0-2.267.618,70.971,70.971,0,0,0-4.368,13.652",
    transform: "translate(-595.307 -90.168)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39575",
    "data-name": "Group 39575",
    transform: "translate(121.115 348.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39574",
    "data-name": "Group 39574",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 58.196,
    height: 51.139,
    transform: "translate(-13.053 6.279) rotate(-25.688)",
    fill: "url(#linear-gradient-23)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39577",
    "data-name": "Group 39577",
    transform: "translate(161.798 348.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39576",
    "data-name": "Group 39576",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 7.821,
    height: 21.394,
    transform: "translate(0)",
    fill: "url(#linear-gradient-24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39579",
    "data-name": "Group 39579",
    transform: "translate(21.157 283.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39578",
    "data-name": "Group 39578",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1059",
    "data-name": "Rectangle 1059",
    width: 48.504,
    height: 14.729,
    fill: "url(#linear-gradient-25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39581",
    "data-name": "Group 39581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39580",
    "data-name": "Group 39580",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80169",
    "data-name": "Path 80169",
    d: "M569.2,1408.808v9.781l7.543,3.115v13.568l54.221,25.68a13.216,13.216,0,0,0,9.026.835l113.186-29.839a10.931,10.931,0,0,0,1.31-20.7L687.818,1384.3a3.967,3.967,0,0,1,.443-7.505l46.437-12.662",
    transform: "translate(-435.552 -1043.823)",
    fill: "none",
    stroke: "#14e2c5",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39583",
    "data-name": "Group 39583",
    transform: "translate(255.05 270.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39582",
    "data-name": "Group 39582",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1061",
    "data-name": "Rectangle 1061",
    width: 234.427,
    height: 71.995,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-26)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39585",
    "data-name": "Group 39585",
    transform: "translate(255.05 227.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39584",
    "data-name": "Group 39584",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1062",
    "data-name": "Rectangle 1062",
    width: 234.623,
    height: 83.814,
    transform: "translate(0)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39587",
    "data-name": "Group 39587",
    transform: "translate(255.05 269.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39586",
    "data-name": "Group 39586",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1063",
    "data-name": "Rectangle 1063",
    width: 234.429,
    height: 71.995,
    transform: "translate(0)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39589",
    "data-name": "Group 39589",
    transform: "translate(255.05 269.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39588",
    "data-name": "Group 39588",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1064",
    "data-name": "Rectangle 1064",
    width: 238.368,
    height: 86.932,
    transform: "translate(-8.036 1.587) rotate(-11.171)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39591",
    "data-name": "Group 39591",
    transform: "translate(291.56 217.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39590",
    "data-name": "Group 39590",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1065",
    "data-name": "Rectangle 1065",
    width: 161.468,
    height: 76.992,
    fill: "url(#linear-gradient-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39593",
    "data-name": "Group 39593",
    transform: "translate(291.56 187.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39592",
    "data-name": "Group 39592",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1066",
    "data-name": "Rectangle 1066",
    width: 161.603,
    height: 57.729,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39595",
    "data-name": "Group 39595",
    transform: "translate(291.56 216.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39594",
    "data-name": "Group 39594",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1067",
    "data-name": "Rectangle 1067",
    width: 161.47,
    height: 76.992,
    transform: "translate(0)",
    fill: "#12151c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39597",
    "data-name": "Group 39597",
    transform: "translate(420.133 250.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39596",
    "data-name": "Group 39596",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1068",
    "data-name": "Rectangle 1068",
    width: 6.131,
    height: 9.565,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39599",
    "data-name": "Group 39599",
    transform: "translate(429.123 247.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39598",
    "data-name": "Group 39598",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1069",
    "data-name": "Rectangle 1069",
    width: 6.131,
    height: 10.463,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39601",
    "data-name": "Group 39601",
    transform: "translate(411.143 253.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39600",
    "data-name": "Group 39600",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1070",
    "data-name": "Rectangle 1070",
    width: 6.132,
    height: 9.009,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39603",
    "data-name": "Group 39603",
    transform: "translate(438.113 240.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39602",
    "data-name": "Group 39602",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    width: 6.132,
    height: 13.003,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39605",
    "data-name": "Group 39605",
    transform: "translate(402.163 255.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39604",
    "data-name": "Group 39604",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1072",
    "data-name": "Rectangle 1072",
    width: 6.122,
    height: 8.59,
    transform: "translate(0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39607",
    "data-name": "Group 39607",
    transform: "translate(420.133 261.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39606",
    "data-name": "Group 39606",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1073",
    "data-name": "Rectangle 1073",
    width: 6.131,
    height: 9.565,
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39609",
    "data-name": "Group 39609",
    transform: "translate(429.123 258.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39608",
    "data-name": "Group 39608",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1074",
    "data-name": "Rectangle 1074",
    width: 6.131,
    height: 10.462,
    transform: "translate(0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39611",
    "data-name": "Group 39611",
    transform: "translate(411.143 264.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39610",
    "data-name": "Group 39610",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1075",
    "data-name": "Rectangle 1075",
    width: 6.132,
    height: 9.009,
    transform: "translate(0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39613",
    "data-name": "Group 39613",
    transform: "translate(438.113 251.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39612",
    "data-name": "Group 39612",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1076",
    "data-name": "Rectangle 1076",
    width: 6.132,
    height: 13.003,
    transform: "translate(0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39615",
    "data-name": "Group 39615",
    transform: "translate(402.163 266.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39614",
    "data-name": "Group 39614",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1077",
    "data-name": "Rectangle 1077",
    width: 6.122,
    height: 8.59,
    transform: "translate(0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39617",
    "data-name": "Group 39617",
    transform: "translate(291.56 216.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39616",
    "data-name": "Group 39616",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1078",
    "data-name": "Rectangle 1078",
    width: 164.183,
    height: 59.877,
    transform: "matrix(0.981, -0.194, 0.194, 0.981, -5.535, 1.093)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39619",
    "data-name": "Group 39619",
    transform: "translate(291.56 162.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39618",
    "data-name": "Group 39618",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1079",
    "data-name": "Rectangle 1079",
    width: 161.468,
    height: 76.992,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-33)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39621",
    "data-name": "Group 39621",
    transform: "translate(291.56 133.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39620",
    "data-name": "Group 39620",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1080",
    "data-name": "Rectangle 1080",
    width: 161.603,
    height: 57.729,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39623",
    "data-name": "Group 39623",
    transform: "translate(291.56 162.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39622",
    "data-name": "Group 39622",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081",
    "data-name": "Rectangle 1081",
    width: 161.469,
    height: 76.992,
    fill: "#12151c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39625",
    "data-name": "Group 39625",
    transform: "translate(420.133 196.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39624",
    "data-name": "Group 39624",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082",
    "data-name": "Rectangle 1082",
    width: 6.131,
    height: 9.565,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39627",
    "data-name": "Group 39627",
    transform: "translate(429.123 192.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39626",
    "data-name": "Group 39626",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083",
    "data-name": "Rectangle 1083",
    width: 6.132,
    height: 10.462,
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39629",
    "data-name": "Group 39629",
    transform: "translate(411.143 199.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39628",
    "data-name": "Group 39628",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084",
    "data-name": "Rectangle 1084",
    width: 6.132,
    height: 9.009,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39631",
    "data-name": "Group 39631",
    transform: "translate(438.113 186.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39630",
    "data-name": "Group 39630",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1085",
    "data-name": "Rectangle 1085",
    width: 6.132,
    height: 13.003,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39633",
    "data-name": "Group 39633",
    transform: "translate(402.163 200.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39632",
    "data-name": "Group 39632",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1086",
    "data-name": "Rectangle 1086",
    width: 6.122,
    height: 8.59,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39635",
    "data-name": "Group 39635",
    transform: "translate(420.133 207.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39634",
    "data-name": "Group 39634",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1087",
    "data-name": "Rectangle 1087",
    width: 6.131,
    height: 9.565,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39637",
    "data-name": "Group 39637",
    transform: "translate(429.123 203.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39636",
    "data-name": "Group 39636",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1088",
    "data-name": "Rectangle 1088",
    width: 6.132,
    height: 10.463,
    transform: "translate(0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39639",
    "data-name": "Group 39639",
    transform: "translate(411.143 210.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39638",
    "data-name": "Group 39638",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1089",
    "data-name": "Rectangle 1089",
    width: 6.132,
    height: 9.009,
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39641",
    "data-name": "Group 39641",
    transform: "translate(438.113 197.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39640",
    "data-name": "Group 39640",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1090",
    "data-name": "Rectangle 1090",
    width: 6.132,
    height: 13.003,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39643",
    "data-name": "Group 39643",
    transform: "translate(402.163 211.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39642",
    "data-name": "Group 39642",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1091",
    "data-name": "Rectangle 1091",
    width: 6.122,
    height: 8.59,
    transform: "translate(0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39645",
    "data-name": "Group 39645",
    transform: "translate(291.56 162.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39644",
    "data-name": "Group 39644",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1092",
    "data-name": "Rectangle 1092",
    width: 164.182,
    height: 59.877,
    transform: "translate(-5.535 1.093) rotate(-11.171)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39647",
    "data-name": "Group 39647",
    transform: "translate(291.559 108.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39646",
    "data-name": "Group 39646",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1093",
    "data-name": "Rectangle 1093",
    width: 161.468,
    height: 76.992,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-36)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39649",
    "data-name": "Group 39649",
    transform: "translate(291.559 79.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39648",
    "data-name": "Group 39648",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 161.603,
    height: 57.729,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39651",
    "data-name": "Group 39651",
    transform: "translate(291.56 108.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39650",
    "data-name": "Group 39650",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095",
    "data-name": "Rectangle 1095",
    width: 161.469,
    height: 76.992,
    transform: "translate(0 0)",
    fill: "#12151c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39653",
    "data-name": "Group 39653",
    transform: "translate(420.133 142.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39652",
    "data-name": "Group 39652",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1096",
    "data-name": "Rectangle 1096",
    width: 6.131,
    height: 9.565,
    transform: "translate(0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39655",
    "data-name": "Group 39655",
    transform: "translate(429.123 138.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39654",
    "data-name": "Group 39654",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1097",
    "data-name": "Rectangle 1097",
    width: 6.132,
    height: 10.462,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39657",
    "data-name": "Group 39657",
    transform: "translate(411.143 144.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39656",
    "data-name": "Group 39656",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1098",
    "data-name": "Rectangle 1098",
    width: 6.132,
    height: 9.009,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39659",
    "data-name": "Group 39659",
    transform: "translate(438.113 131.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39658",
    "data-name": "Group 39658",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1099",
    "data-name": "Rectangle 1099",
    width: 6.132,
    height: 13.003,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39661",
    "data-name": "Group 39661",
    transform: "translate(402.163 146.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39660",
    "data-name": "Group 39660",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1100",
    "data-name": "Rectangle 1100",
    width: 6.122,
    height: 8.59,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39663",
    "data-name": "Group 39663",
    transform: "translate(420.133 153.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39662",
    "data-name": "Group 39662",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1101",
    "data-name": "Rectangle 1101",
    width: 6.131,
    height: 9.565,
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39665",
    "data-name": "Group 39665",
    transform: "translate(429.123 149.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39664",
    "data-name": "Group 39664",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1102",
    "data-name": "Rectangle 1102",
    width: 6.132,
    height: 10.463,
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39667",
    "data-name": "Group 39667",
    transform: "translate(411.143 155.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39666",
    "data-name": "Group 39666",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 6.132,
    height: 9.009,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39669",
    "data-name": "Group 39669",
    transform: "translate(438.113 142.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39668",
    "data-name": "Group 39668",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 6.132,
    height: 13.003,
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39671",
    "data-name": "Group 39671",
    transform: "translate(402.163 157.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39670",
    "data-name": "Group 39670",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 6.122,
    height: 8.59,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39673",
    "data-name": "Group 39673",
    transform: "translate(291.559 107.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39672",
    "data-name": "Group 39672",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 164.183,
    height: 59.877,
    transform: "matrix(0.981, -0.194, 0.194, 0.981, -5.535, 1.093)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39684",
    "data-name": "Group 39684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39683",
    "data-name": "Group 39683",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39676",
    "data-name": "Group 39676",
    transform: "translate(291.559 216.738)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39675",
    "data-name": "Group 39675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39674",
    "data-name": "Group 39674",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80216",
    "data-name": "Path 80216",
    d: "M1301.227,950.905c-13.831,17.305-31.226,29.269-50.471,33.55-5.782-3.972-9.052-8.49-9.052-13.285V923.048c0,13.317,25.224,24.522,59.524,27.858",
    transform: "translate(-1241.702 -923.048)",
    fill: "url(#linear-gradient-5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39679",
    "data-name": "Group 39679",
    transform: "translate(291.559 162.416)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39678",
    "data-name": "Group 39678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39677",
    "data-name": "Group 39677",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80217",
    "data-name": "Path 80217",
    d: "M1322.494,720.58q2.52,0,4.991-.057a150.446,150.446,0,0,1-21.888,47.535c-36.51-2.773-63.895-14.361-63.895-28.233V691.7c0,15.943,36.168,28.877,80.792,28.877",
    transform: "translate(-1241.701 -691.702)",
    fill: "url(#linear-gradient-5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39682",
    "data-name": "Group 39682",
    transform: "translate(291.559 108.105)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39681",
    "data-name": "Group 39681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39680",
    "data-name": "Group 39680",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80218",
    "data-name": "Path 80218",
    d: "M1333.74,495.618a184.01,184.01,0,0,1-4.7,41.673q-3.241.1-6.549.1c-44.624,0-80.792-12.934-80.792-28.869V460.4c0,15.943,36.167,28.869,80.792,28.869q5.664,0,11.123-.278.123,3.291.122,6.63",
    transform: "translate(-1241.702 -460.397)",
    fill: "url(#linear-gradient-5)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39686",
    "data-name": "Group 39686",
    transform: "translate(326.105 91.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39685",
    "data-name": "Group 39685",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    width: 92.512,
    height: 33.048,
    transform: "translate(0 0)",
    fill: "#14e2c5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41172",
    "data-name": "Group 41172",
    transform: "translate(1377.731 532.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41157",
    "data-name": "Group 41157",
    transform: "translate(29.838 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41156",
    "data-name": "Group 41156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41154",
    "data-name": "Group 41154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39396_00000082369063725820569850000014136147221644146613_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79773_00000147918923915039504010000013583581780589998976_",
    d: "M10.69,11.443l.128-8.079-4.3,7.692-.756.174L1.769,5.53l-.195,8.006L0,13.9.281,2.878l1.334-.315,4.6,6.622L11.1.323,12.452,0l-.169,11.073Z",
    transform: "translate(0 15.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79774_00000182505562563589514870000005018021897153039007_",
    d: "M7.754,3.409,7.7,8.513l-1.526.351L6.19,7.745a3.464,3.464,0,0,1-.492.625,3.984,3.984,0,0,1-.655.532,4.871,4.871,0,0,1-.812.425,6.141,6.141,0,0,1-.965.3,4.685,4.685,0,0,1-1.353.129A2.444,2.444,0,0,1,.893,9.484a1.585,1.585,0,0,1-.641-.636,1.914,1.914,0,0,1-.213-.954,2.753,2.753,0,0,1,.2-1,2.841,2.841,0,0,1,.612-.922,4.127,4.127,0,0,1,1.1-.783,7.4,7.4,0,0,1,1.664-.581l2.533-.589,0-.3a2.073,2.073,0,0,0-.138-.825,1.153,1.153,0,0,0-.435-.534,1.517,1.517,0,0,0-.734-.223,3.527,3.527,0,0,0-1.035.106,5.315,5.315,0,0,0-.751.229,5.82,5.82,0,0,0-.727.341,6.182,6.182,0,0,0-.688.445,6.351,6.351,0,0,0-.635.54L.363,2.815A8.36,8.36,0,0,1,1.2,2.139a8.094,8.094,0,0,1,.9-.553,7.582,7.582,0,0,1,.944-.42,6.884,6.884,0,0,1,.97-.277,5.563,5.563,0,0,1,1.6-.169,2.425,2.425,0,0,1,1.179.353,1.9,1.9,0,0,1,.724.89,3.671,3.671,0,0,1,.238,1.444M6.12,6.3l.013-1.179-2.47.573a4.748,4.748,0,0,0-.986.332,2.313,2.313,0,0,0-.627.425,1.405,1.405,0,0,0-.435,1.018,1.034,1.034,0,0,0,.125.539.852.852,0,0,0,.379.343,1.509,1.509,0,0,0,.609.132,3.238,3.238,0,0,0,.817-.093A4.2,4.2,0,0,0,4.4,8.094a3.684,3.684,0,0,0,.732-.456,3.294,3.294,0,0,0,.584-.6A3.125,3.125,0,0,0,6.12,6.3",
    transform: "translate(14.029 15.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79775_00000040575768685372459710000013902422709726699690_",
    d: "M8.514,3.664,8.5,8.551l-1.629.375L6.89,4.217a3.008,3.008,0,0,0-.157-1.048,1.435,1.435,0,0,0-.467-.661,1.477,1.477,0,0,0-.755-.283,3.08,3.08,0,0,0-1.021.087,4.249,4.249,0,0,0-1.166.453,3.371,3.371,0,0,0-.893.741,3.2,3.2,0,0,0-.574,1.009A3.853,3.853,0,0,0,1.648,5.77l-.031,4.364L0,10.506.071,2.063,1.609,1.7,1.6,2.97a4.267,4.267,0,0,1,.582-.708,4.853,4.853,0,0,1,.743-.6A5.536,5.536,0,0,1,3.808,1.2,6.261,6.261,0,0,1,4.813.87a4.649,4.649,0,0,1,1.5-.129,2.45,2.45,0,0,1,1.171.4,2.16,2.16,0,0,1,.763.963,3.976,3.976,0,0,1,.27,1.559",
    transform: "translate(23.88 12.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79776_00000013188764374670843390000014176691026332612511_",
    d: "M7.853,3.435,7.876,8.58l-1.56.359,0-1.127a3.439,3.439,0,0,1-.5.632,4.008,4.008,0,0,1-.664.538,4.953,4.953,0,0,1-.827.431,6.321,6.321,0,0,1-.985.309,4.874,4.874,0,0,1-1.386.134A2.563,2.563,0,0,1,.9,9.581a1.639,1.639,0,0,1-.667-.639A1.916,1.916,0,0,1,0,7.982,2.717,2.717,0,0,1,.192,6.976a2.816,2.816,0,0,1,.615-.931,4.165,4.165,0,0,1,1.117-.793,7.6,7.6,0,0,1,1.7-.591l2.59-.6v-.3a2.069,2.069,0,0,0-.153-.831A1.186,1.186,0,0,0,5.6,2.387a1.591,1.591,0,0,0-.757-.222,3.668,3.668,0,0,0-1.06.111,5.477,5.477,0,0,0-.767.233,5.935,5.935,0,0,0-.741.346,6.256,6.256,0,0,0-.7.45,6.376,6.376,0,0,0-.643.546L.262,2.862a8.425,8.425,0,0,1,.845-.684,8.208,8.208,0,0,1,.913-.56,7.763,7.763,0,0,1,.962-.427A7.1,7.1,0,0,1,3.972.909,5.792,5.792,0,0,1,5.616.734a2.546,2.546,0,0,1,1.216.351,1.951,1.951,0,0,1,.756.895,3.653,3.653,0,0,1,.264,1.455M6.221,6.352l0-1.188L3.691,5.75a4.883,4.883,0,0,0-1.006.338,2.338,2.338,0,0,0-.637.431,1.387,1.387,0,0,0-.432,1.028,1.034,1.034,0,0,0,.136.543.882.882,0,0,0,.393.344,1.582,1.582,0,0,0,.627.131,3.369,3.369,0,0,0,.837-.1,4.3,4.3,0,0,0,.869-.3,3.741,3.741,0,0,0,.744-.462,3.3,3.3,0,0,0,.59-.61,3.088,3.088,0,0,0,.407-.744",
    transform: "translate(33.863 10.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79777_00000109740308610099488230000015194550962610040243_",
    d: "M9.549.084l.092,7.37a6.282,6.282,0,0,1-.283,2.038,4.5,4.5,0,0,1-.893,1.584,5.129,5.129,0,0,1-1.486,1.149,8.4,8.4,0,0,1-2.059.734,9.882,9.882,0,0,1-1.252.2,7.955,7.955,0,0,1-1.192.028,5.42,5.42,0,0,1-1.065-.159,3.237,3.237,0,0,1-.871-.357l.786-1.38a4.335,4.335,0,0,0,.8.306,4.851,4.851,0,0,0,.867.155,5.481,5.481,0,0,0,.918,0,6.155,6.155,0,0,0,.949-.153,5.723,5.723,0,0,0,1.4-.5,3.3,3.3,0,0,0,.977-.762A2.894,2.894,0,0,0,7.8,9.311,4.215,4.215,0,0,0,7.978,8L7.97,7.319a5.692,5.692,0,0,1-.684.745,5.773,5.773,0,0,1-.8.609,5.533,5.533,0,0,1-.879.454,5.043,5.043,0,0,1-.929.279,5.375,5.375,0,0,1-1.842.122A3.468,3.468,0,0,1,1.364,9.02a2.786,2.786,0,0,1-.98-1.082,3.52,3.52,0,0,1-.361-1.6A4.587,4.587,0,0,1,.364,4.581a5.2,5.2,0,0,1,.961-1.519A6.063,6.063,0,0,1,2.781,1.887a6.65,6.65,0,0,1,1.826-.724A4.594,4.594,0,0,1,5.563,1a3.925,3.925,0,0,1,.906.052,3.345,3.345,0,0,1,.822.256,2.958,2.958,0,0,1,.7.454L7.979.452ZM7.973,4.491a2.382,2.382,0,0,0-.247-1.076A1.835,1.835,0,0,0,7.066,2.7a2.323,2.323,0,0,0-1-.329,3.787,3.787,0,0,0-1.26.1,4.664,4.664,0,0,0-1.264.494,4.041,4.041,0,0,0-.989.792A3.436,3.436,0,0,0,1.913,4.77a3.108,3.108,0,0,0-.225,1.182,2.386,2.386,0,0,0,.24,1.072,1.864,1.864,0,0,0,.657.73,2.328,2.328,0,0,0,1,.343,3.742,3.742,0,0,0,1.272-.089,4.538,4.538,0,0,0,1.261-.5,4.06,4.06,0,0,0,.99-.8,3.5,3.5,0,0,0,.643-1.032,3.1,3.1,0,0,0,.221-1.182",
    transform: "translate(43.1 8.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79778_00000113323712686485272670000001176223944245941417_",
    d: "M9.236,4.877,1.731,6.618a2.231,2.231,0,0,0,.368.943,1.988,1.988,0,0,0,.723.627,2.655,2.655,0,0,0,1.025.275,4.259,4.259,0,0,0,1.271-.112,4.172,4.172,0,0,0,.747-.224,4.571,4.571,0,0,0,.709-.361,4.762,4.762,0,0,0,.646-.482A4.7,4.7,0,0,0,7.778,6.7l.948.793a5.314,5.314,0,0,1-.7.765,5.817,5.817,0,0,1-.851.635,6.521,6.521,0,0,1-.985.495,7.374,7.374,0,0,1-1.1.344,6,6,0,0,1-2.044.142,3.639,3.639,0,0,1-1.581-.549A2.949,2.949,0,0,1,.438,8.166,3.82,3.82,0,0,1,.059,6.49,4.978,4.978,0,0,1,.382,4.664a5.487,5.487,0,0,1,.944-1.6A6,6,0,0,1,2.773,1.826a6.23,6.23,0,0,1,1.836-.755A5.048,5.048,0,0,1,6.449.957a3.3,3.3,0,0,1,1.462.556,2.977,2.977,0,0,1,.975,1.167A4.166,4.166,0,0,1,9.263,4.4c0,.032,0,.068,0,.107s0,.08-.006.122-.005.085-.008.127-.006.082-.01.12m-7.522.629L7.641,4.127a2.125,2.125,0,0,0-.383-.959A2.071,2.071,0,0,0,6.5,2.536a2.515,2.515,0,0,0-1.021-.253,3.276,3.276,0,0,0-1.18.18,3.914,3.914,0,0,0-.967.486,4.077,4.077,0,0,0-.793.715,3.751,3.751,0,0,0-.56.875,3.1,3.1,0,0,0-.267.965",
    transform: "translate(54.1 5.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79779_00000142135239812502407770000011953114073591596190_",
    d: "M9.666,11.827,5.815,7.982l-3.54,5.543-2.029.466,4.5-6.9L.278,2.618l1.993-.47L5.822,5.67l3.3-5.14L11.052.075,6.839,6.553l4.871,4.8Z",
    transform: "translate(65.187)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41159",
    "data-name": "Group 41159",
    transform: "translate(0 17.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41158",
    "data-name": "Group 41158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39951",
    "data-name": "Group 39951",
    transform: "translate(2.982 0.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39950",
    "data-name": "Group 39950",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1210",
    "data-name": "Rectangle 1210",
    d: "M.479,4.487,19.432,0,19.1,10.836,0,15.239Z",
    transform: "translate(0 0)",
    fill: "url(#pattern-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39953",
    "data-name": "Group 39953",
    transform: "translate(13.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39952",
    "data-name": "Group 39952",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    d: "M.49,2.763,12.161,0l-.382,13.215L0,15.916Z",
    fill: "url(#pattern-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39955",
    "data-name": "Group 39955",
    transform: "translate(7.956 9.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39954",
    "data-name": "Group 39954",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    d: "M.235,2.058,9.086,0l-.2,5.76L0,7.8Z",
    fill: "url(#pattern-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39957",
    "data-name": "Group 39957",
    transform: "translate(0 3.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39956",
    "data-name": "Group 39956",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    d: "M.609,2.722,12.1,0l-.5,13.144L0,15.8Z",
    fill: "url(#pattern-8)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCaseSpecificNew);
export default __webpack_public_path__ + "static/media/Use-Case-Specific_new.9a9c0551122c6b69946c16d981b71c44.svg";
export { ForwardRef as ReactComponent };